export default __webpack_public_path__ + "static/media/group-option-hairmale-selected.104a5c2c.svg";